import React, { useState } from 'react';
import { Accordion } from './Accordion';
import { Check } from 'lucide-react';
const tomes = [{
  icon: '🇦🇷',
  title: 'TOMO 1 — Repertorio para Actos Escolares y Efemérides',
  quote: 'Nunca más buscar el Himno o Aurora a las apuradas antes del acto.',
  items: ['Repertorio completo para las fechas patrias (25 de Mayo, 20 de Junio, 9 de Julio, 17 de Agosto)', 'Himno Nacional Argentino adaptado a flauta dulce', 'Contexto histórico breve para introducir cada canción en el acto', 'Nivel de dificultad y digitación de notas complicadas', 'Listo para imprimir y repartir'],
  image: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&q=80&w=600'
}, {
  icon: '🎄',
  title: 'TOMO 2 — Villancicos y Fin de Año',
  quote: 'El repertorio de diciembre, resuelto de una vez.',
  items: ['Villancicos tradicionales adaptados a flauta dulce', 'Canciones de cierre de ciclo lectivo', 'Sugerencia de arreglo simple con guitarra o piano', 'Nivel de dificultad por canción'],
  image: 'https://images.unsplash.com/photo-1512909006721-3d6018887383?auto=format&fit=crop&q=80&w=600'
}, {
  icon: '🪕',
  title: 'TOMO 3 — Folklore Argentino y Latinoamericano',
  quote: 'Zambas, chacareras y clásicos latinoamericanos, adaptados al aula.',
  items: ['Folklore argentino simplificado para nivel escolar', 'Dato cultural breve para enseñar junto con cada canción', 'Clásicos latinoamericanos reconocibles', 'Digitación de notas complejas resuelta'],
  image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&q=80&w=600'
}, {
  icon: '🎧',
  title: 'TOMO 4 — Pop y Música Infantil Actual',
  quote: 'Para enganchar a los chicos con lo que ya escuchan.',
  items: ['Adaptaciones simplificadas de música pop actual', 'Bandas sonoras y temas infantiles populares', 'Tips de motivación para captar la atención del curso', 'Rango de notas apto para flauta dulce escolar'],
  image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&q=80&w=600'
}, {
  icon: '🎼',
  title: 'TOMO 5 — Clásicos Internacionales',
  quote: 'Beethoven, Pachelbel y más, simplificados para el aula.',
  items: ['Himno a la Alegría, Para Elisa, Canon de Pachelbel (fragmentos)', 'Dato histórico breve de cada compositor', 'Nivel de dificultad y digitación resuelta'],
  image: 'https://images.unsplash.com/photo-1507838153414-b4b713384a76?auto=format&fit=crop&q=80&w=600'
}, {
  icon: '🌱',
  title: 'TOMO 6 — Método de Iniciación Progresivo',
  quote: 'Para alumnos que arrancan de cero, grado por grado.',
  items: ['Progresión pedagógica de 1er a 6to grado', 'Tabla de digitación completa al inicio', 'Ejercicios cortos y canciones simples por etapa', 'Errores comunes de los alumnos y cómo corregirlos'],
  image: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&q=80&w=600'
}];
export function Tomes() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <section className="bg-navy text-white py-12" data-id="element-305">
      <div className="max-w-md mx-auto px-4" data-id="element-306">
        <div className="flex justify-center mb-4" data-id="element-307">
          <div className="inline-flex items-center gap-2 bg-navy-light text-white px-3 py-1.5 rounded-full text-xs font-bold border border-white/10" data-id="element-308">
            <span data-id="element-309">📦</span>
            <span data-id="element-310">Sistema Completo</span>
          </div>
        </div>

        <h2 className="text-[28px] leading-tight font-extrabold text-center mb-4" data-id="element-311">
          6 tomos. +200 partituras. Todo resuelto.
        </h2>
        <p className="text-center text-gray-light mb-8 text-[15px]" data-id="element-312">
          Del acto armado a las apuradas, al repertorio que ya está listo.
        </p>

        <div className="space-y-3 mb-8" data-id="element-313">
          {tomes.map((tomo, idx) => <Accordion key={idx} isOpen={openIndex === idx} onToggle={() => setOpenIndex(openIndex === idx ? -1 : idx)} icon={tomo.icon} title={<span className="text-[15px]" data-id="element-315">{tomo.title}</span>} className="bg-navy-light border border-white/5" headerClassName="hover:bg-white/5" data-id="element-314">
              <div className="pt-2" data-id="element-316">
                <p className="italic text-turquoise text-sm mb-4" data-id="element-317">
                  "{tomo.quote}"
                </p>
                <ul className="space-y-2 mb-4" data-id="element-318">
                  {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-light" data-id="element-319">
                      <Check className="w-4 h-4 text-turquoise shrink-0 mt-0.5" data-id="element-320" />
                      <span data-id="element-321">{item}</span>
                    </li>)}
                </ul>
                <div className="rounded-xl overflow-hidden h-40 w-full relative" data-id="element-322">
                  <img src={tomo.image} alt={tomo.title} className="w-full h-full object-cover" data-id="element-323" />
                </div>
              </div>
            </Accordion>)}
        </div>

        <div className="bg-white/5 border border-white/10 p-5 rounded-2xl" data-id="element-324">
          <p className="font-bold mb-3 text-sm" data-id="element-325">Cada tomo incluye:</p>
          <ul className="space-y-2 text-sm text-gray-light" data-id="element-326">
            {['Partituras listas para usar tal cual', 'Digitación simplificada de notas complejas', 'Contexto pedagógico para introducir cada canción', 'Nivel de dificultad por partitura', '100% adaptado al aula argentina'].map((item, idx) => <li key={idx} className="flex items-center gap-2" data-id="element-327">
                <Check className="w-4 h-4 text-turquoise shrink-0" data-id="element-328" />
                <span data-id="element-329">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}